import { useState } from "react";
import { Navigate } from "react-router-dom";
import { notificationImageUplaodRequest } from "../../network/service/ImageUploadService";
import { useDispatch } from "react-redux";

function CreateNotification() {

    const [selectedImage, setSelectedImage] = useState(null)
    const dispatch = useDispatch();

      const [createNotificationForm, setcreateNotificationForm] = useState({
        name: "",
        description: "",
      });
     const handleChanges = (e) => {

    setcreateNotificationForm({ ...createNotificationForm, [e.target.name]: e.target.value });
  };

  const handleImageChange = (event) => {
    // Check if a file was selected
    if (event.target.files && event.target.files[0]) {
      setSelectedImage(event.target.files[0]);
    }
  }

  const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
  ];

  const [selectedValue, setSelectedValue] = useState(options[0].value);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  }

    const uploadImage = async () => {
      const form_data = new FormData();
      form_data.append("file", selectedImage);
      form_data.append("title", createNotificationForm.name);
      form_data.append("message", createNotificationForm.description);
      let requestBody = {
        fileData: form_data,
      };
      await dispatch(notificationImageUplaodRequest(requestBody)).then(
        (response) => {
          setcreateNotificationForm(
            {
      name: '',
      description: ''
    }
          )
        }
      );
    };
  
  return (
    <>

      <main className="container-fluid dashboard">
        <div className="row justify-content-around tble">
          <div style={{ marginLeft: "50px" }}>
            <h3 className="dashboard-title">Create Notification</h3>
          </div>
        </div>
        <div className="row m-3">

          <div className="col-md-6">
            <div className="form-group">
              <label>Title</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={createNotificationForm.name}
                onChange={(e) => handleChanges(e)}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Message</label>
              <textarea
                type="text"
                name="description"
                className="form-control"
                value={createNotificationForm.description}
                onChange={(e) => handleChanges(e)}
              />
            </div>
          </div>

             <div className="col-md-6">
           <input
        type="file"
        name="myImage"
        accept="image/*" // Restricts file selection to images
        onChange={handleImageChange}
      />
          </div>

          <div className="col-md-6">
            {selectedImage && (
        <div>
          <img
            alt="not found"
            width={"250px"}
            // Create a temporary URL for the selected file to display it
            src={URL.createObjectURL(selectedImage)} 
          />
          <br />
          {/* <button onClick={() => setSelectedImage(null)}>Remove</button> */}
        </div>
      )}
          </div>
          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
            }}
          >
                

            <button
              style={{ display: "flex", justifyContent: "center" }}
              type="button"
              className="btn btn-purple-bg"
             onClick={() => uploadImage()}
            >
              Submit
            </button>
            {/* <button className="btn btn-white-bg" onClick={() => navigate(-1)}>
              Cancel
            </button> */}
          </div>
        </div>
      </main>
    </>
  );
}
export default CreateNotification;
